import { NotificationAlert } from 'core/classes/NotificationAlert';
import { fetchRefreshTokenGraphQL } from 'core/config/gql/fetchRefreshToken';
import { AUTH } from 'core/datasets/action';
import { coreActions } from 'core/redux/actions/coreActions';
import { Middleware } from 'redux';
import { authActions, refreshExpiredToken } from 'tenantUser/redux/authActions';

export const refreshTokenMiddleware: Middleware =
    ({ dispatch, getState }) =>
    (next) =>
    async (action) => {
        const server = process.env.REACT_APP_GQL_SERVER_URL;

        if (action.type === AUTH.REQUEST_TO_REFRESH_EXPIRED_TOKEN) {
            if (server) {
                try {
                    const refreshToken = getState().auth.refresh_token;
                    const { token } = await fetchRefreshTokenGraphQL(refreshToken);
                    dispatch(refreshExpiredToken(token));
                } catch (error) {
                    console.error('[Fetch RefreshToken error]', error);
                    dispatch(authActions.setLogout());
                    dispatch(
                        coreActions.notification.set(
                            new NotificationAlert({
                                message: 'tenantUser.notices.authExpired',
                                level: NotificationAlert.WARNING,
                            }),
                        ),
                    );
                }
            }
        }

        return next(action);
    };
